export enum BenefitPageState {
  LOADING = 'LOADING',
  ERROR = 'ERROR',
  CONTENT = 'CONTENT',
}
